//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: "",
// },

export const geometryURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=11XvQUw1yJ5Ie4HyFy-HaPySKaVL319lu",
    frame: "Alka talkies chowk",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1I1AtcnCp8UWxD_xZwys6Qwq1PA5vsVhm",
    frame: "Streets",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1b09rhE_I3pt1r5zRBSSKkchWbZppZ5Sd",
    frame: "Global education center",
    location: "Infosys Ltd., Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dnZJl7kJ_FRxjyhEekdjoXOkyAeGz6H8",
    frame: "Tipu sultan palace",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cmMf8OunAj9xFEmWhmmujgNAYw7UaMHt",
    frame: "Guitar strings (leading lines)",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1idN5lMJEZE7olRQ39jvn0LObNSGoluEt",
    frame: "Low key shot of a guitar",
    location: "Meerut, Uttar Pradesh, India",
  },
];
